import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyAccountRoutingModule } from './my-account-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { MyAccountComponent } from './pages/my-account/my-account.component';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { UpdateComponent } from './pages/update/update.component';

@NgModule({
  declarations: [MyAccountComponent, ChangePasswordComponent, UpdateComponent],
  imports: [
    CommonModule,
    MyAccountRoutingModule,
    SharedModule,
    FlexLayoutModule,
  ],
})
export class MyAccountModule {}
